import { motion } from "framer-motion";
import { IMAGES } from "../../data/site";

const ease = [0.22, 1, 0.36, 1];

const PARAS = [
  "Hi, I'm Amber — writer, coach and founder of Modern Mind. Radiate was born from finding my own way back to myself — from a constant, underlying feeling that I wasn't on my path. Made for more, yet so far from that place. This was never about becoming someone else — it's about remembering and reconnecting with your radiance.",
  "I grew up moving house almost every year, raised by a single mother while I watched my father move through addiction. I learned early to shrink, to perform, to earn my worth.",
  "Years in the modelling industry only deepened it — hormonal acne, relentless comparison, and a quiet sense that I'd drifted far from who I really was and what I was worth.",
  "So I went looking. I studied neurolinguistic programming and began rewiring the stories running underneath the surface. I started sharing my writing with the world — words that now reach millions of people every month.",
  "From that same place I landed a six-figure publishing deal for my first book — a dream I'd held for as long as I can remember — met my now husband, and had my beautiful son.",
  "Worlds away from where I began. That shift is exactly what Radiate is built to help you feel.",
];

const Para = ({ text, i }) => (
  <motion.p
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, ease, delay: i * 0.05 }}
    className="text-base leading-relaxed text-white/60 md:text-lg"
  >
    {text}
  </motion.p>
);

export const Story = () => (
  <section
    id="story"
    className="relative z-10 mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32"
    data-testid="story-section"
  >
    <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-16">
      {/* image */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease }}
        className="md:col-span-5"
      >
        <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] border border-white/10 md:sticky md:top-24">
          <img
            src={IMAGES.founder}
            alt="Amber, founder of Modern Mind"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c]/70 to-transparent" />
          <p className="absolute bottom-6 left-6 font-display text-sm font-light tracking-[0.2em] text-white/80">
            AMBER · FOUNDER OF MODERN MIND
          </p>
        </div>
      </motion.div>

      {/* story */}
      <div className="md:col-span-7">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease }}
          className="mb-6 text-xs font-semibold uppercase tracking-[0.35em] text-white/40"
        >
          The story
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease }}
          className="font-display text-3xl font-thin leading-[1.1] tracking-tight text-white md:text-5xl"
        >
          From low self-worth to my{" "}
          <span className="italic text-white/80">most magnetic life.</span>
        </motion.h2>

        <div className="mt-10 space-y-6">
          {PARAS.map((t, i) => (
            <Para key={i} text={t} i={i} />
          ))}
        </div>
      </div>
    </div>
  </section>
);
